import { Card, Col, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Rest from "../../../../libraries/Rest";
import Alert from "../../../../libraries/Alert";
import * as Components from "../../../../components/Components";
import Validator from "../../../../libraries/Validator";

function CompanyBankForm() {
    const { companyId, id } = useParams();
    const navigate = useNavigate();
    const rest = new Rest();

    const isCreate = id?.toLowerCase() === 'add' ? true : false;

    /**
     * Init validator of payload
     */
    const validator = new Validator({
        name: { required: true },
        code: { required: true },
        description: { required: true },
        bank_code: { required: true },
    });

    /**
     * Init states
     */
    const rootPath = `/companies/banks/${companyId}`;
    const endpoint = `/companies/banks/${companyId}`;

    let [payload, setPayload] = useState({
        code: null,
        bank_code: null,
        name: null,
        description: null,
    });
    let [banks, setBanks] = useState([]);

    /**
     * First init function
     */
    const getDataById = async () => {
        const response = await rest.get(`${endpoint}/${id}`);
        if (response?.data?.data !== undefined) {
            const data = response.data.data;
            setPayload({
                code: data?.code,
                bank_code: data?.bank_code,
                name: data?.name,
                description: data?.description,
            });
        } else {
            Alert.showMessage('Error', 'error', 'Data is not found');
            navigate(rootPath);
        }
    }

    const getBanks = async () => {
        const response = await rest.get(`/statics/banks`);
        if (response?.data?.data !== undefined) {
            const data = response.data.data;
            let options = [];
            for (let i = 0; i < data.length; i++) {
                options.push({
                    label: `(${data[i]?.code}) ${data[i]?.name}`,
                    value: data[i]?.code,
                });
            }
            setBanks(options);
        }
    }

    useEffect(() => {
        async function __init() {
            Alert.showLoading();
            await getBanks();
            if (!isCreate) await getDataById();
            Alert.close();
        }
        __init();
    }, []);


    /**
     * Action handlers
     */
    const updatePayload = (field, value) => {

        /**
         * If field === bank_code, then you need to get the bank name and put it into payload.description
         */
        if (field === 'bank_code') {
            const x = banks.find(x => x?.value === value);
            if (x !== undefined) setPayload({
                ...payload,
                [field]: value,
                'description': x?.label?.substring(6, x?.label?.length)
            });
        } else {
            setPayload({ ...payload, [field]: value });
        }
    }

    const submit = async () => {
        /**
         * Validate input
         */
        const errMessages = validator.validate(payload);
        if (errMessages.length > 0) {
            let errMessageStrings = ``;
            for (let i = 0; i < errMessages.length; i++) {
                errMessageStrings += `${errMessages[i]}<br />`;
            }
            return Alert.showMessage(`Invalid input`, `warning`, errMessageStrings);
        }

        /**
         * Submit action
         */
        Alert.showConfirm({
            url: endpoint + (!isCreate ? `/${id}` : ``),
            method: isCreate ? 'POST' : 'PUT',
            data: payload,
        }).then((result) => {
            if (result.isConfirmed) {
                if (result?.value?.success) {
                    Alert.showMessage('Success', 'success', result?.value?.data?.message);
                    navigate(rootPath);
                } else {
                    Alert.showMessage('Failure', 'error', result?.value?.message);
                }
            }
        });
    }

    /**
     * Rendering DOM
     */
    return (
        <div>
            <div className="d-flex align-items-center justify-content-between mb-4">
                <div>
                    <ol className="breadcrumb fs-sm mb-1">
                        <li className="breadcrumb-item">
                            <Link to="/dashboard">Dashboard</Link>
                        </li>
                        <li className="breadcrumb-item">
                            <Link to="/companies">List companies</Link>
                        </li>
                        <li className="breadcrumb-item">
                            <Link to={rootPath}>List banks</Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            Form {isCreate ? 'create' : 'edit'}
                        </li>
                    </ol>
                </div>
            </div>

            <Row className="g-3">
                <Col xl="12">
                    <Card className="card">
                        <Card.Header className="bg-primary">
                            <Card.Title
                                as="label"
                                className="fs-sm fw-medium mb-1 text-white"
                            >
                                Form {isCreate ? 'create' : 'edit'} bank
                            </Card.Title>
                        </Card.Header>
                        <Card.Body className="bg-white">
                            <Link to={rootPath} className="btn btn-sm btn-warning text-white">
                                <i className="ri-arrow-left-line"></i> Back
                            </Link>
                            &nbsp;
                            <button className="btn btn-sm btn-primary" onClick={submit}>
                                <i className="ri-check-line"></i> Save
                            </button>
                            <br /><br />
                            <Row className="g-3">
                                <Col sm="3">
                                    <Components.Input
                                        type="number"
                                        name="code"
                                        label="Account number"
                                        placeholder="e.g: 8123xxxx"
                                        defaultValue={payload.code}
                                        change={updatePayload}
                                    />
                                </Col>
                                <Col sm="3">
                                    <Components.Input
                                        type="text"
                                        name="name"
                                        label="Account name"
                                        placeholder="e.g: Your company name"
                                        defaultValue={payload.name}
                                        change={updatePayload}
                                    />
                                </Col>
                                <Col sm="6">
                                    <Components.Select
                                        name="bank_code"
                                        label="Bank"
                                        defaultValue={payload.bank_code}
                                        change={updatePayload}
                                        options={banks}
                                    />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default CompanyBankForm;